import React from "react";
import AppHeader from "../../../components/Header/Header";
import AppLayout from "../../../components/layout";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';



export default function Eventos(){
    const blogData = [
  {
    id: 1,
    image: require('../../../assets/ANU_02.jpg'),
    category: 'Outorga',
    time: '16-Julho-2024',
    title: '3ª Cerimônia de Outorga de Diplomas',
    description: 'Na Cerimônia de Outorga de Diplomas doInstituto Superior Politécnico Atlântida, os formandos da turma de 2024 se reuniram ansiosos no auditório. Com discursos inspiradores, eles receberam seus diplomas.',
    link: '#'
  },
  {
    id: 2,
    image: require('../../../assets/ANU_02_4.jpg'),
    category: 'Comemoração',
    time: '07-Setembro-2023  | 09H - 12H',
    title: '5ª Jornada Científica Geral',
    description: 'No tradicional evento do Baptismo dos Caloiros, os novos estudantes se reuniram em um clima de excitação e nervosismo, eles participaram de rituais simbólicos e receberam as boas-vindas da comunidade acadêmica. Após o evento, os caloiros se integraram ainda mais à vida universitária,',
    link: '#'
  },
  {
    id: 3,
    image: require('../../../assets/ANU_02_10.jpg'),
    category: 'Investigação',
    time: '07-Abril-2023 ',
    title: 'Juventude Investigadora: Construindo o Futuro da Ciência',
    description: 'O evento proporcionou uma oportunidade única para a comunidade acadêmica trocar ideias, colaborar em projetos e promover o avanço do conhecimento científico.',
    link: '#'
  }
  ,
  {
    id: 4,
    image: require('../../../assets/ANU_02_11.jpg'),
    category: 'Comemoração',
    time: '07-Outubro-2023 ',
    title: 'Juventude, Conhecimento e Segurança: Um Compromisso Social',
    description: 'A atividade realizada, sob o tema “Juventude, Conhecimento e Segurança: Um Compromisso Social” marcou um momento de grande significado para a comunidade académica e para as forças de segurança',
    link: '#'
  }
  ,
  {
    id: 5,
    image: require('../../../assets/ANU_02_6.jpg'),
    category: 'Evento Cultural',
    time: '22-Agosto-2023 ',
    title: 'Entre Letras e Ideias: Construindo Conhecimento Através da Leitura',
    description: 'A Feira do Livro realizada sob o tema “Entre Letras e Ideias: Construindo Conhecimento Através da Leitura” celebrou a leitura como uma ponte viva entre o saber e a imaginação, entre o passado e o futuro.',
    link: '#'
  }
  ,
  {
    id: 6,
    image: require('../../../assets/ANU_02_5.jpg'),
    category: 'Investigação Científica',
    time: '05-Fevereiro-2024  ',
    title: 'Semana da Investigação e Extensão Universitária',
    description: 'Esta atividade não apenas valorizou o saber produzido no ambiente acadêmico, mas também fortaleceu a relação entre a universidade e a sociedade, evidenciando o compromisso institucional com a formação integral dos estudantes e com o desenvolvimento sustentável da região.',
    link: '#'
  }
  ,
  {
    id: 7,
    image: require('../../../assets/ANU_02_7.jpg'),
    category: 'Jornada Científica',
    time: '14-Março-2023 ',
    title: '5ª Jornada Científica Geral',
    description: 'A 5ª Jornada Científica Geral foi um marco no calendário acadêmico do Instituto Superior, reunindo estudantes, professores, investigadores e membros da comunidade em um espaço de partilha de conhecimento, experiências e inovação.',
    link: '#'
  }
  ,
  {
    id: 8,
    image: require('../../../assets/ANU_02_8.jpg'),
    category: 'Evento Acadêmico',
    time: '23-Maio-2024  ',
    title: 'A Universidade como Espaço de Produção de Saberes e Impacto Social',
    description: 'O evento proporcionou uma oportunidade única para a comunidade acadêmica trocar ideias, colaborar em projetos e promover o conhecimento científico.',
    link: '#'
  }
  ,
  {
    id: 9,
    image: require('../../../assets/ANU_04.jpg'),
    category: 'Investigação Científica',
    time: '07-Setembro-2023  ',
    title: 'Jornada Científica Geral',
    description: 'O evento teve como objetivo principal promover a produção e a divulgação do conhecimento científico nas diversas áreas do saber, incentivando a interdisciplinaridade, a inovação e o pensamento crítico.',
    link: '#'
  }
    ,
]

    // Destaques: por exemplo, os 3 primeiros eventos
    const destaques = blogData.slice(0, 3);
    // Todos os eventos
    const todosEventos = blogData.slice(3,13);


    return(
        <div className="App">
        <div className="banner position-relative" id="backImage">
            <div className="title-banner" id="banner">
            <h1 style={{color:'white'}}>Eventos</h1>
            <h3>Você encontrará informações sobre eventos acadêmicos, oportunidades de pesquisa,<br /> bolsas de estudo, serviços disponíveis e atividades extracurriculares.<br /> </h3>
            </div>
        </div>
        <header id='header'>
        <AppHeader />
        </header>
        <main>
            {/* Eventos em Destaques */}
            <section id="blog" className="block blog-block">
                <div className="title-holder" id='title-' >
                    <h1>Evento Em Destaque</h1>
                    <p style={{ color: 'gray' }}>- Principais Acontecimentos - </p>
                </div>
                <Container fluid>
                    <Row>
                        {destaques.map(blog => (
                            <Col sm={4} key={blog.id}>
                                <div style={{ marginTop: '12px' }} className='holder'>
                                    <Link to={`/evento/${blog.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                        <Card style={{ cursor: 'pointer' }}>
                                            <Card.Img variant="top" src={blog.image} />
                                            <Card.Body>
                                                <span style={{ color: '#00761F', fontWeight: '700' }}>{blog.category}</span>
                                                <time>{blog.time}</time>
                                                <Card.Title>
                                                    {blog.title}
                                                </Card.Title>
                                                <Card.Text>
                                                    {blog.description}
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Link>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
            {/* Todos os Eventos */}
                <section id="todos-eventos" className="block blog-block" style={{ marginTop: '40px' }}>
                    <div className="title-holder" id='title-todos' >
                        <h1>Todos os Eventos</h1>
                        <p style={{ color: 'gray' }}>- Veja todos os eventos realizados - </p>
                    </div>
                    <Container fluid>
                        <Row>
                            {todosEventos.map(blog => (
                                <Col sm={4} key={blog.id}>
                                    <div style={{ marginTop: '12px' }} className='holder'>
                                        <Card as={Link} to={`/evento/${blog.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                            <Card.Img variant="top" src={blog.image} />
                                            <Card.Body>
                                                <span style={{ color: '#00761F', fontWeight: '700' }}>{blog.category}</span>
                                                <time>{blog.time}</time>
                                                <Card.Title>{blog.title}</Card.Title>
                                                <Card.Text>
                                                    {blog.description}
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </section>
            </main>
        <AppLayout />
        </div>
    )
}
